import {Controller} from '@hotwired/stimulus';

/**
 * - les formulaires se postent en ajax, la réponse se met dans le div
 * - les liens aussi
 */
export default class extends Controller {
  static targets = [];
  static values = {
  };

  initialize() {
    this.onSubmit = this.onSubmit.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connect() {
    this.element.addEventListener('submit', this.onSubmit);
    this.element.addEventListener('click', this.onClick);
  }

  disconnect() {
    this.element.removeEventListener('submit', this.onSubmit);
    this.element.removeEventListener('click', this.onClick);
  }

  onSubmit(event) {
    // submit le form en ajax
    const form = event.target;

    if (form.dataset.fetchFrameEnabled === 'false') {
      return;
    }

    event.preventDefault();

    const submitter = event.submitter;
    const formDatas = new FormData(form, submitter);
    const method = (submitter?.formMethod || form.method).toUpperCase();
    const url = new URL(submitter?.hasAttribute('formaction') ? submitter.formAction : form.action);
    const options = {method};

    if (method === 'GET') {
      url.search = new URLSearchParams(formDatas).toString();
    } else {
      options.body = formDatas;
    }

    this.#load(url, options, this.#getDestination(form), (response) => {
      // permet de savoir ailleurs en JS si un form a été valid ou pas
      this.dispatch('form-response', {
        detail: {
          form: form,
          response: response,
        },
      });
    });
  }

  onClick(event) {
    // si c'est bien un lien
    const link = event.target.closest('a');

    if (!link || !this.element.contains(link)) {
      return;
    }

    // nouvel onglet, nouvelle fenêtre, téléchargement : laissés au navigateur
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }

    if (link.dataset.fetchFrameEnabled === 'false') {
      return;
    }

    event.preventDefault();

    // fetch le lien en ajax
    this.#load(link.href, {}, this.#getDestination(link));
  }

  displayLoader() {
    this.element.setAttribute('aria-busy', 'true');
  }

  hideLoader() {
    this.element.removeAttribute('aria-busy');
  }

  #load(url, options, destination, onResponse = () => {}) {
    this.displayLoader();

    fetch(url, options)
      .then((response) => {
        onResponse(response);

        // redirigé hors du fragment (page du site, connexion) : on y va comme une navigation normale
        if (response.redirected) {
          window.location.assign(response.url);
          return;
        }

        // 422 : formulaire invalide, rendu avec ses erreurs
        if (!response.ok && response.status !== 422) {
          throw new Error(`${response.status} ${response.statusText}`);
        }

        return response.text().then((data) => {
          destination.innerHTML = data;
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.hideLoader();
      });
  }

  #getDestination(element) {
    return element.dataset.fetchFrameDestination ?
      document.querySelector(element.dataset.fetchFrameDestination) :
      this.element;
  }
}
